module.exports = __webpack_public_path__ + "static/img/officialCertification_light.629649cb.png";